import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import './index.css';
import AppIt from "./App";
import AppEn from "./AppEn";
import PDFPage from "./PDFPage";
import CookiePolicyIt from "./pages/CookiePolicyIt";
import CookiePolicyEn from "./pages/CookiePolicyEn";

ReactDOM.createRoot(document.getElementById("root")).render(
  <BrowserRouter>
    <Routes>
      {/* Italiano: root */}
      <Route path="/" element={<AppIt />} />

      {/* Cookie Policy IT */}
      <Route path="/cookie-policy" element={<CookiePolicyIt />} />

      {/* Inglese: /en/* */}
      <Route path="/en/*" element={<AppEn />} />

      {/* Cookie Policy EN */}
      <Route path="/en/cookie-policy" element={<CookiePolicyEn />} />

      {/* Altre pagine EN (es. gender-equality) */}
      <Route path="/en/gender-equality" element={<PDFPage />} />

      {/* Qualsiasi altro path -> torna alla root IT */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  </BrowserRouter>
);